export default __webpack_public_path__ + "static/media/runner2.23659045.png";